import { SyntheticEvent, useState } from 'react'
import detailFunction from '../crudFunctions/detailFunction'
import { client } from '../../interfaces'
import EditClientModal from './EditClientModal'

interface props {
  setShowSearchModal: React.Dispatch<React.SetStateAction<boolean>>
  setShowEditModal: React.Dispatch<React.SetStateAction<boolean>>
  setSingleClient: React.Dispatch<React.SetStateAction<null | client>>
  singleClient: null | client
  showEditModal: boolean
  trigger: boolean
  setTrigger: React.Dispatch<React.SetStateAction<boolean>>
  setShowDeleteClientModal: React.Dispatch<React.SetStateAction<boolean>>
}

const SearchClientModal = ({
  setShowSearchModal,
  setShowEditModal,
  setSingleClient,
  singleClient,
  showEditModal,
  trigger,
  setTrigger,
  setShowDeleteClientModal
}: props) => {
  const [query, setQuery] = useState<string>('')
  const [searchResult, setSearchResult] = useState<client | null>(null)
  const [isError, setIsError] = useState<boolean>(false)
  const [searchMethod, setSearchMethod] = useState<string>('Telefono')
  const [clientResult, setClientResult] = useState<null | client[]>(null)

  const handleSearch = (e: SyntheticEvent): void => {
    e.preventDefault()
    if (searchMethod === 'Telefono') {
      const endpoint: string = `client/${query}`
      detailFunction(endpoint).then((response: client) => {
        if (response) {
          setClientResult(null)
          setSearchResult(response)
          setSingleClient(response)
          setIsError(false)
        } else {
          setSearchResult(null)
          setIsError(true)
        }
      })
    } else {
      const endpoint: string = `client/search/${query}`
      detailFunction(endpoint).then((response: client[]) => {
        if (response) {
          setSearchResult(null)
          setClientResult(response)
          setIsError(false)
        } else {
          setClientResult(null)
          setIsError(true)
        }
      })
    }
  }
  return (
    <>
      {showEditModal && (
        <EditClientModal
          setShowEditModal={setShowEditModal}
          singleClient={singleClient}
          trigger={trigger}
          setTrigger={setTrigger}
        />
      )}
      <div id='searchClientModal' className='modal'>
        <div className='modal-content grid justify-items-center rounded-md'>
          <form className='grid' onSubmit={handleSearch}>
            <label htmlFor='method'>Buscar por:</label>
            <select
              name='method'
              id='method'
              defaultValue={'Telefono'}
              className='border-2 border-black rounded-md text-center mb-5'
              onChange={(e) => {
                setSearchMethod(e.target.value)
                setQuery('')
              }}>
              <option value='Telefono'>Telefono</option>
              <option value='Nombre'>Nombre</option>
            </select>
            <label htmlFor='query' className='text-lg'>
              {searchMethod}:
            </label>
            <input
              type='text'
              name='query'
              value={query}
              id='query'
              className='border-2 border-black rounded-md text-center mb-5'
              onChange={(e) => {
                if (searchMethod === 'Telefono') {
                  setQuery(e.target.value.replace(/\D/, ''))
                } else {
                  setQuery(e.target.value)
                }
              }}
            />

            <button
              type='submit'
              className='bg-viper  text-white text-xl rounded-lg w-3/4 place-self-center px-8 py-2 mb-5 shadow-lg'>
              <span>Buscar</span>
            </button>
            {searchResult && (
              <>
                <table className='table-fixed w-full mx-auto text-lg'>
                  <tbody>
                    <tr key={searchResult.id}>
                      <td className='border-2 text-center'>
                        {searchResult.name} {searchResult.phone}
                        <button
                          className='float-right ml-10 mr-8 text-red-400'
                          onClick={() => {
                            setSingleClient(searchResult)
                            setShowSearchModal(false)
                            setShowDeleteClientModal(true)
                          }}>
                          X
                        </button>
                        <button
                          className='float-right text-gray-500'
                          onClick={() => {
                            setSingleClient(searchResult)
                            setShowEditModal(true)
                          }}>
                          Editar
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </>
            )}

            {clientResult && (
              <table className='table-fixed w-full mx-auto text-lg'>
                <tbody>
                  {clientResult.map((client: client) => {
                    return (
                      <tr key={client.id}>
                        <td className='border-2 text-center'>
                          {client.name} {client.phone}
                          <button
                            className='float-right ml-10 mr-8 text-red-400'
                            onClick={() => {
                              setSingleClient(client)
                              setShowSearchModal(false)
                              setShowDeleteClientModal(true)
                            }}>
                            X
                          </button>
                          <button
                            className='float-right text-gray-500'
                            onClick={() => {
                              setSingleClient(client)
                              setShowEditModal(true)
                            }}>
                            Editar
                          </button>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            )}

            {isError && (
              <p className='text-center text-lg mt-5'>No existe ese cliente</p>
            )}
          </form>
          <button
            className='bg-red-400  text-white text-xl rounded-lg px-8 py-2 mt-10 shadow-lg'
            onClick={() => {
              setShowSearchModal(false)
              setSearchResult(null)
            }}>
            <span>Cerrar</span>
          </button>
        </div>
      </div>
    </>
  )
}

export default SearchClientModal
